module.exports = __webpack_public_path__ + "logo1.2067b38e.png";